/* eslint-disable @typescript-eslint/no-unused-vars */
import { Service } from 'common/services/service';

import { toCamelCaseObject } from 'common/helpers/utils';
import { Country } from 'common/types/global';

import END_POINTS from '../config/constants/urls';
import { buildPathWithParams } from '../helpers/url';
import ApiClient from './http-client';

interface AppInitResponse {
  countries: Country[];
  message: string;
}

export class SettingsService extends Service {
  static appInit = async () => {
    SettingsService.setCall('appInit', ApiClient.cancelTokenSource());
    try {
      return await ApiClient.post<{ countries: Country[] }>(END_POINTS.init);
    } catch {
      return { countries: [] as Country[] };
    }
  };

  static getCountryByIp = async () => {
    SettingsService.setCall('getCountryByIp', ApiClient.cancelTokenSource());
    try {
      const response = await ApiClient.get<{ iso: string }>(END_POINTS.getCountryByIp);
      return response.iso;
    } catch {
      return 'BR';
    }
  };

  static getCountries = async () => {
    SettingsService.setCall('getCountries', ApiClient.cancelTokenSource());
    try {
      const response = await ApiClient.get<{ countries: Country[] }>(END_POINTS.getCountries);
      return response.countries.map((c) => toCamelCaseObject<Country>(c));
    } catch {
      return [];
    }
  };

  static getCountryConfig = async () => {
    SettingsService.setCall('getCountryConfig', ApiClient.cancelTokenSource());
    try {
      const response = await ApiClient.get<{ country: Country }>(END_POINTS.getCountryConfig);
      return toCamelCaseObject<Country>(response.country);
    } catch (error) {
      return Promise.reject(error);
    }
  };
  static cancelAppInit = () => {
    SettingsService.cancelRequest('appInit');
  };

  static cancelGetCountryByIp = () => {
    SettingsService.cancelRequest('getCountryByIp');
  };

  static cancelGetCountries = () => {
    SettingsService.cancelRequest('getCountries');
  };

  static cancelGetCountryConfig = () => {
    SettingsService.cancelRequest('getCountryConfig');
  };
}

export default SettingsService;
